import { API } from '../helpers/fetcher'

export const mobilePayAuthentication = async params =>
    API.post('v1/transaction/mobile-pay/authenticate', params)